import { Injectable, Inject} from '@angular/core';
import { Http, Response, Headers, RequestOptions} from '@angular/http';
import { Validators, ValidatorFn } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import 'rxjs/add/operator/map';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Service to get pattern for field validation.
 **/
@Injectable()
export class ValidateService {

  constructor() { }


	validateCtrl(ctrl){
        return ctrl.valid || ctrl.untouched;
	}


	getPattern(min?, max?){
		//let rname = new RegExp('^\s*([a-zA-Z@.&*()\-+\/\' ]\s*){'+min+','+max+'}$');
		return {
			//'name':'^[a-zA-Z@.&*()-/+/\' ]{'+min+','+max+'}$',
			'name': /^\s*([a-zA-Z@.&*()\u2018\u2019\u201C\u201D\-+\/\'\`\, ]\s*){2,80}$/,
			'passport':'^[a-zA-Z0-9]{'+min+','+max+'}$',
			'numberOnly': '^[0-9]{'+min+','+max+'}$',
			'alphaOnly':'^[a-zA-Z]{'+min+','+max+'}$',
			'alphaNumeric':'^[a-zA-Z0-9]{'+min+','+max+'}$',
			//'email':'^[0-9a-zA-Z-_\.]+@([0-9a-zA-Z-_]+\.)+[0-9a-zA-Z-_]{2,4}$',
			'email': /^[0-9a-zA-Z-_\.]+@([a-zA-Z0-9]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?\.)?([a-zA-Z0-9]{1,2}([-a-zA-Z0-9]{0,252}[a-zA-Z0-9])?)\.([a-zA-Z]{2,3})$/,
			'phoneNo':'^[0-9]{3}+[-]+^[0-9]{8,9}',
			'ic':'^[0-9]{12,12}$',
			'lat': /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
			'lng': /^[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/
			// 'latlong':'^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$',
			};
	}

	getMask(){
		return {
			'telephone' : [ /[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/,/\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
			'telephonef': ['+', /[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
			'icno': [ /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
			'postcode':[/\d/, /\d/, /\d/, /\d/, /\d/],
			'dateFormat':[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
			'icno2': [ /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
			'policeReportNo': [ /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
		}
	}


}



// WEBPACK FOOTER //
// ./src/app/common/validate.service.ts